import React from "react";
import CompanyReportSection from "shared/reports/components/companyReportSection/CompanyReportSection";
import ReportsCollectionWrapper from "shared/reports/components/reportsCollectionWrapper/ReportsCollectionWrapper";
import TargetProgressBar from "goalsCard/tabs/ScoreCardReport/targetProgressBar/TargetProgressBar";
import TargetProgressInfo from "goalsCard/tabs/ScoreCardReport/targetProgressInfo/TargetProgressInfo";
import { ScorecardGoal } from "goalsCard/service/api/models";
import { ScorecardGoalV3_PublicStatus } from "shared/service/api/generated";
import { goalCodes } from "shared/constants/reportConstants";

interface CompanyScoreReportSectionProps {
    companyName?: string;
    goals: ScorecardGoal[];
    todayProgressValue?: number;
    additionalClassName?: string;
}

const CompanyScoreReportSection: React.FC<CompanyScoreReportSectionProps> = (props: CompanyScoreReportSectionProps) => {
    const renderGoal = (report: ScorecardGoal) => {
        return (
            <>
                {report.title !== goalCodes.apeGz && (
                    <TargetProgressBar
                        targetProgress={report.progress}
                        targetProgressValue={report.progressValue}
                        todayProgressValue={props.todayProgressValue}
                        showWarningIndicator={report.status === ScorecardGoalV3_PublicStatus.NOK ? true : false}
                        highlightTextTargetProgressValue={true}
                        showTodayProgressValue={
                            props.todayProgressValue !== undefined && props.todayProgressValue <= 101
                        }
                        showOnlyProgressValue={report.title !== goalCodes.lapse}
                    />
                )}
                <TargetProgressInfo report={report} />
            </>
        );
    };

    const getReportElementTitle = (goal: ScorecardGoal) => {
        return goal.title;
    };

    const getReportElementText = (goal: ScorecardGoal) => {
        return goal.text;
    };

    const getReportContents = () => {
        if (!props.goals) {
            return null;
        }

        return (
            <ReportsCollectionWrapper
                reports={props.goals}
                reportElementTitle={getReportElementTitle}
                reportElementText={getReportElementText}
                renderReportElement={renderGoal}
            />
        );
    };

    return (
        <CompanyReportSection
            companyName={props.companyName}
            reportContents={getReportContents()}
            additionalClassName={props.additionalClassName}
        />
    );
};

export default CompanyScoreReportSection;
